export enum WalletTransactionMethod {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  PRODUCT_PURCHASE = 'PRODUCT_PURCHASE',
  PRODUCT_INSTALLMENT_PAYMENT = 'PRODUCT_INSTALLMENT_PAYMENT',
  PRODUCT_RESIDUAL_RETURN = 'PRODUCT_RESIDUAL_RETURN',
  PRODUCT_CANCELLATION = 'PRODUCT_CANCELLATION',
  AGENT_COMMISSION_INITIAL = 'AGENT_COMMISSION_INITIAL',
  AGENT_INCENTIVE = 'AGENT_INCENTIVE',
  METAL_DELIVERY_CHARGES = 'METAL_DELIVERY_CHARGES',
  AGENT_COMMISSION_ON_DELIVERY = 'AGENT_COMMISSION_ON_DELIVERY',
  DIRECT_SALE_PURCHASE = 'DIRECT_SALE_PURCHASE'
}
